import { QueryKey, MutationKey } from '@tanstack/react-query';

export const adminCredentialsKeys: QueryKey = ['admin', 'service', 'credentials', 'managment'];
export const queryAdminCredentialsKeys: QueryKey = adminCredentialsKeys.concat('query');
export const retrieveCredentialsKeys: QueryKey = adminCredentialsKeys.concat('retrieve');

export const createCredentialMutationKeys: MutationKey = ['admin', 'credentials', 'create'];
export const updateCredentialMutationKeys: MutationKey = ['admin', 'credentials', 'update'];
export const removeCredentialMutationKeys: MutationKey = ['admin', 'credentials', 'remove'];
